export default __webpack_public_path__ + "static/media/audioread screenshot.71f872db.svg";